export default class ContactTypes {
  static LEGAL_PERSON = "legalPerson";

  static NATURAL_PERSON = "naturalPerson";
}
